import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Output } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { QnSbnDataServiceService } from '../../services/qn-sbn-data-service.service';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { snackbarService } from '@one/web-components';
import { CustomConfirmationDialogComponent } from '../../custom-confirmation-dialog/custom-confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'dl-edit-workflow',
  standalone: true,
  imports:[OneWebComponentsAngularModule,FormsModule],
  templateUrl: './edit-workflow.component.html',
  styleUrl: './edit-workflow.component.scss'
})
export class EditWorkflowComponent {

  public isCancelDialogOpen: boolean = false; // Flag to control modal
  public localNotificationId = 'SBN-CPS-2020-014_UK';
  public storedData: any;
  public DueDateEnabled: boolean = true;
  public feedbackEnabled: boolean = true;
  public nonSavedFeedback: boolean = false;
  public isValid: boolean = false;
  public fbDisabledAndEnabled: boolean = false;
  public feedbackAdded: boolean = false;

  @Output() public cancelBtnState = new EventEmitter<boolean>();

  constructor(
    private _QnSbnDataService: QnSbnDataServiceService,
    private qnsbnService: QnSbnService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this._QnSbnDataService.mappingData$.subscribe(storeData => {
      this.storedData = storeData;
    });

    this.localNotificationId = this.qnsbnService.getLocalNotificationID();

    this._QnSbnDataService.DueDateEnabled$.subscribe(res => {
      this.DueDateEnabled = res;
    });

    this._QnSbnDataService.FeedbackEnabled$.subscribe(res => {
      this.feedbackEnabled = res;
    });
  }

  public cancelNotificationProcess(): void {

            this._QnSbnDataService.isAfoBtnDisabled$.subscribe(
          res =>{
            this.nonSavedFeedback = res;
        })
        this._QnSbnDataService.isValidFeedback$.subscribe(
          res =>{
            this.isValid = res;
        })
         this._QnSbnDataService.fbDisabledAndEnabled$.subscribe(
          res =>{
            this.fbDisabledAndEnabled = res;
          } 
        )
        this._QnSbnDataService.isFeedbackAdded$.subscribe(
          res =>{
            this.feedbackAdded = res;
          } 
        )
        if((this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && !this.feedbackAdded) || 
          (this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && this.feedbackAdded) ||
          (!this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && !this.feedbackAdded) ||
          (!this.nonSavedFeedback && this.isValid && this.fbDisabledAndEnabled )){
          const nonSavedFeedbackDialogRef = this.dialog.open(CustomConfirmationDialogComponent, {
            data: {
              title: 'Warning',
              message: 'You have changes not applied in the feedback form controls. Please apply them to continue.',
              confirmButtonText: 'Accept'
            }
          });
          nonSavedFeedbackDialogRef.afterClosed().subscribe((confirmed: boolean) => {
            return
          })
          this._QnSbnDataService.isAfoBtnDisabled$.next(true);
          this._QnSbnDataService.fbDisabledAndEnabled$.next(false);
        }else{
             this.isCancelDialogOpen = true;
              this.cancelBtnState.emit(true);
        }
  }

  public discard(): void {
    this.isCancelDialogOpen = false;
    this._QnSbnDataService.resetAll();
    this.router.navigateByUrl('/notification');
    this.snackBarMessage('positive',`Progress in new local notification ${this.localNotificationId} discarded successfully`);
    // show toast if needed
  }

  public saveChanges(): void {
    this.isCancelDialogOpen = false;
    this.saveCloseNotification();
  }

  public async saveCloseNotification(): Promise<void> {
    await this._QnSbnDataService.setDDToggle(this.DueDateEnabled);
    await this._QnSbnDataService.setFBToggle(this.feedbackEnabled);

    let saveNCloseData;
    this._QnSbnDataService.mappingData$.subscribe(storeData => {
      this.storedData = storeData;
    });

    if (!this._QnSbnDataService.isEmpty(this.storedData)) {
      saveNCloseData = this._QnSbnDataService.saveNcloseData(this.storedData);
    }

    const fileData = this._QnSbnDataService.fileUploadData(this.storedData);
    sessionStorage.setItem('reloadOverview', 'true');

    if (fileData.length > 0) {
      for (let f = 0; f < fileData.length; f++) {
        if (fileData[f].uploadFile) {
          this.qnsbnService.dataToBeSaveOnS3(
            saveNCloseData,
            fileData[f],
            this.storedData['localNotificationId']['NotificationId'],
            f === fileData.length - 1,
            false
          );
        } else if (f === fileData.length - 1) {
          this.saveNCloseDraftApiCall(saveNCloseData);
        }
      }
    } else {
      this.saveNCloseDraftApiCall(saveNCloseData);
    }
  }

  public async saveNCloseDraftApiCall(saveNCloseData): Promise<void> {
    await this._QnSbnDataService.setDDToggle(this.DueDateEnabled);
    await this._QnSbnDataService.setFBToggle(this.feedbackEnabled);

    this.qnsbnService.saveNCloseNotificationData(saveNCloseData).subscribe(
      res => {
        this._QnSbnDataService.resetAll();
        this.router.navigateByUrl('/notification');
         this.snackBarMessage('positive','Local notification saved successfully');
      },
      (error: HttpErrorResponse) => {
        this.qnsbnService.httpErrorHandler(error, 'Local notification not saved successfully');
      }
    );
  }

  snackBarMessage(status: any, message: string) {
      snackbarService.show({
        message: message,
        snackbarProps: {
          status: status,
          direction: 'horizontal',
          showClose: true,
          elevated: false,
          duration: 5000,
          verticalPlacement: 'top',
          horizontalPlacement: 'right',
        }
      });
    }
}


